<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="header">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Vending Category List
        </h4>

        <div class="d-flex">
          <!-- <div class="mr-2">
            <button
              type="button"
              class="btn btn-outline-primary"
              ngbTooltip="Download sample CSV format"
              placement="top"
              (click)="downloadSampleCSV()"
            >
              <i class="fa fa-download"></i> Sample CSV
            </button>
          </div>
          <div class="mr-2">
            <label for="csvUpload" class="btn btn-primary mb-0">
              <i class="fa fa-upload"></i> Upload CSV
            </label>
            <input
              type="file"
              id="csvUpload"
              accept=".csv"
              style="display: none"
              (change)="uploadCategoryCSV($event)"
            />
          </div> -->
          <a
            href="javascript: void(0);"
            class="btn btn-primary"
            placement="top"
            (click)="openModal(editModal, {}, 'Add Category')"
            ngbTooltip="Add Category"
          >
            + Add Category
          </a>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-striped border mt-4">
          <thead class="table-light">
            <tr>
              <th scope="col">Sequence Number</th>
              <th scope="col">Category</th>
              <th scope="col">Created At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let category of categoryData; let i = index">
              <td>{{ category?.sortCount }}</td>
              <td>
                <p placement="top">
                  {{ category?.category_name }}
                </p>
              </td>
              <td>{{ category.created_at | date : "medium" }}</td>
              <td>
                <button
                  class="btn btn-sm btn-primary mr-1"
                  (click)="handleProductList(category)"
                  ngbTooltip="List products"
                >
                  <i class="fa fa-list"></i>
                </button>
                <button
                  class="btn btn-sm btn-primary mr-1"
                  (click)="openModal(editModal, category, 'Edit Category')"
                  ngbTooltip="Edit Category"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  class="btn btn-sm btn-danger ms-1"
                  (click)="openDeleteModal(deleteModal, category._id)"
                  ngbTooltip="Delete"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="categoryData?.length === 0 && !loading">
              <td colspan="3" class="text-center text-muted">
                No category records found.
              </td>
            </tr>
          </tbody>
        </table>

        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="categoryData?.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalCount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editProductLabel">{{ modeltitle }}</h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form (ngSubmit)="onSubmit()" #categoryForm="ngForm">
    <div class="modal-body">
      <div class="form-group">
        <label for="categoryName"
          >Category Name <span class="text-danger">*</span></label
        >
        <input
          type="text"
          class="form-control"
          [class.is-invalid]="
            categoryName.invalid && (categoryName.dirty || categoryName.touched)
          "
          id="categoryName"
          name="categoryName"
          [(ngModel)]="detail.category_name"
          placeholder="Enter category name"
          required
          #categoryName="ngModel"
        />
        <div
          class="invalid-feedback"
          *ngIf="
            categoryName.invalid && (categoryName.dirty || categoryName.touched)
          "
        >
          <div *ngIf="categoryName.errors?.required">
            Category name is required
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="sequenceNumber">
          Sequence Number <span class="text-danger">*</span>
        </label>
        <input
          type="number"
          class="form-control"
          id="sortCount"
          name="sortCount"
          [(ngModel)]="detail.sortCount"
          placeholder="Enter sequence number"
          required
          #sortCount="ngModel"
        />
        <div
          class="invalid-feedback"
          *ngIf="sortCount.invalid && (sortCount.dirty || sortCount.touched)"
        >
          <div *ngIf="sortCount.errors?.required">
            Sequence number is required
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
        Close
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="categoryForm.invalid"
      >
        {{ modeltitle === "Add Category" ? "Add Category" : "Update Category" }}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="deleteModalLabel">Delete Category</h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">Are you sure you want to delete this category?</div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="closeDeleteModalClick()"
    >
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      Delete
    </button>
  </div>
</ng-template>
